// import React from 'react';
// import { Card } from "react-bootstrap";

// import './imageBlock.module.css';

// const ImageBlock = ({ ratio, banner }, ...props) => {

//     const pT = (ratio[0] / ratio[1]) * 100;

//     return (
//         <div styleName="imgBlockWrap">
//             <Card.Img styleName="imgBlockWrap__img" variant="top" src={ !!banner && banner } style={{ paddingTop: pT + '%' }} />
//         </div>
//     )
// }

// export default ImageBlock;


import React from "react";
import PropTypes from "prop-types";
import Observer from "react-intersection-observer";

import "./imageBlock.module.css";

const ImageBlock = (props) => {
  const { src, alt, width, height, ...rest } = props;

  return (
    <div styleName="root" style={{ "--maxWidth": width }}>
      <Observer triggerOnce={true}>
        {({ inView, ref }) => (
          <div
            ref={ref}
            styleName="wrapper"
            style={{
              "--height": height,
              "--width": width
            }}
          >
            <img
              src={inView ? src : ""}
              alt={alt}
              width={width}
              height={height}
              styleName="img"
              {...rest}
            />
          </div>
        )}
      </Observer>
    </div>
  );
}

export default ImageBlock;

ImageBlock.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  src: PropTypes.string.isRequired,
};